/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProjectApiKey } from '../models/project-api-key';
import { ProjectApiKeyWithRelations } from '../models/project-api-key-with-relations';

@Injectable({
  providedIn: 'root',
})
export class ProjectApiKeyControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation projectApiKeyControllerGenerate
   */
  static readonly ProjectApiKeyControllerGeneratePath = '/project-api-keys/generate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `generate()` instead.
   *
   * This method doesn't expect any request body.
   */
  generate$Response(params?: {
  }): Observable<StrictHttpResponse<ProjectApiKey>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectApiKeyControllerService.ProjectApiKeyControllerGeneratePath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectApiKey>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `generate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  generate(params?: {
  }): Observable<ProjectApiKey> {

    return this.generate$Response(params).pipe(
      map((r: StrictHttpResponse<ProjectApiKey>) => r.body as ProjectApiKey)
    );
  }

  /**
   * Path part for operation projectApiKeyControllerFindLatest
   */
  static readonly ProjectApiKeyControllerFindLatestPath = '/project-api-keys/latest';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findLatest()` instead.
   *
   * This method doesn't expect any request body.
   */
  findLatest$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<ProjectApiKeyWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectApiKeyControllerService.ProjectApiKeyControllerFindLatestPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectApiKeyWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findLatest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findLatest(params?: {
    filter?: any;
  }): Observable<ProjectApiKeyWithRelations> {

    return this.findLatest$Response(params).pipe(
      map((r: StrictHttpResponse<ProjectApiKeyWithRelations>) => r.body as ProjectApiKeyWithRelations)
    );
  }

  /**
   * Path part for operation projectApiKeyControllerFindByIdForWorkflow
   */
  static readonly ProjectApiKeyControllerFindByIdForWorkflowPath = '/project-api-keys/{projectId}/by-workflow';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByIdForWorkflow()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByIdForWorkflow$Response(params: {
    projectId: string;
  }): Observable<StrictHttpResponse<ProjectApiKeyWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectApiKeyControllerService.ProjectApiKeyControllerFindByIdForWorkflowPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectApiKeyWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findByIdForWorkflow$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByIdForWorkflow(params: {
    projectId: string;
  }): Observable<ProjectApiKeyWithRelations> {

    return this.findByIdForWorkflow$Response(params).pipe(
      map((r: StrictHttpResponse<ProjectApiKeyWithRelations>) => r.body as ProjectApiKeyWithRelations)
    );
  }

}
